import { TabPane } from "reactstrap";
import CommonTabContentTable from "./CommonTabContentTable";

const FirstTabContent = () => {
  return (
    <TabPane tabId="1">
      <div className="custom-scrollbar">
        <CommonTabContentTable value={5} />
      </div>
    </TabPane>
  );
};

export default FirstTabContent;
